import axios from 'core/network/interceptor';
import { GetValueOptionsUrl } from './constants';

interface Options {
    namespace: string;
    label: string;
    key: string;
    value: string;
}

interface valueOptionEntryVariables {
    namespace: string;
    category: string;
    parentCategory?: string;
    parentValue?: string;
}

export interface ValueOptionResult {
    options: Array<Options>;
}

const GetValueOptionsRequest = async ({namespace, category, parentCategory, parentValue}: valueOptionEntryVariables) => {
    let params : any = {'namespace': namespace, 'category': category};
    if (parentCategory && parentValue) params = {...params, 'parent_category': parentCategory, 'parent_value': parentValue};

    const response = await axios.get(GetValueOptionsUrl, {'params': params});

    return response.data;
};
 export { GetValueOptionsRequest };